<template class="arr">
  <div>
    <div class="content">
      <div class="menu-box" @mouseover="mouseOver">
        <!-- 展示与隐藏侧边栏 开始-->
        <!-- <input type="checkbox" id="menu-btn" /> -->
        <label for="menu-btn" @click="close"></label>
        <!-- 展示与隐藏侧边栏 结束-->
        <div class="menu" :class="open ? 'open' : ''">
          <div class="popup-top">
            <div class="popup-text">数字化运营中心</div>
          </div>
          <div class="open-content">
            <div class="elSelect" v-if="largeScreenType != 2">
              <!-- 医院 -->
              <el-select
                v-if="hospitalList && hospitalList.length > 0"
                class="departSelect"
                popper-class="select"
                v-model="param.default_hospital"
                size="mini"
                filterable
                @change="changeHospital"
              >
                <el-option
                  class="option"
                  v-for="(item, index) in hospitalList"
                  :key="index"
                  :label="item.hospitalName"
                  :value="item.hospitalId"
                >
                </el-option>
              </el-select>
              <!-- 分析 -->
              <el-select
                class="departSelect departSelect2"
                popper-class="select"
                v-model="param.type"
                size="mini"
                
                @change="changeType"
              >
                <el-option
                  class="option"
                  v-for="(item, index) in searchTypeList"
                  :key="index"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <!-- 选择日期和年 -->
              <el-date-picker
                v-if="param.type === 'year' || param.type === 'month'"
                class="monthPicker"
                size="mini"
                v-model="param.time"
                :type="param.type"
                :format="dateFormat"
                :clearable="false"
                popper-class="date-picker"
                @change="changeDate"
              >
              </el-date-picker>
              <!-- 自由选择日期至日期 -->
              <el-date-picker
                v-if="param.type === 'datetimerange'"
                class="datetimerange"
                v-model="value1"
                :type="param.type"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                @change="DateTimeRange"
              >
              </el-date-picker>
              <el-button type="primary" class="elButton" @click="query"
                >查询</el-button
              >
            </div>
            <div class="large-screen">
              <div
                class="large-screen-type"
                :class="largeScreenType == 1 ? 'is-large-screen-type' : ''"
              >
                <div @click="pathSwitching('dx')">
                  <img
                    class="large-screen-type-img"
                    src="../assets/popup-icon.png"
                    alt=""
                  />
                </div >
              </div>
              <div
                class="large-screen-type"
                :class="largeScreenType == 2 ? 'is-large-screen-type' : ''"
              >
                <div>
                  <div
                    class="large-screen-type-img"
                    style="background: beige"
                    @click="pathSwitching('dd')"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import util from "@/utils/util.js";
export default {
  props: {
    hospitalList: {
      type: Array,
      default: ()=>[],
    },
    largeScreenType:{ // 当前大屏
      type: Number,
      default: 1,
    }
  },
  data() {
    return {
      util,
      open: false,
      isClose: true,
      dateFormat: "yyyy年 M月份", //时间显示格式
      value1: "",
      searchType: "month",
      param: {
        departId: "", //科室ID
        type: "cumulative", //日期搜索类型
        time: "", //搜索时间
        equName: "", //设备名称
        model: "", //设备型号
        sn: "", //设备序列号
        default_hospital: "所有医院",
      },
      hospital_infor: {
        hospitalName: "", // 医院名称
        hospitalId: "", // 医院id
      },
      searchTypeList: [
        {
          name: "累计分析",
          value: "cumulative",
        },
        {
          name: "月度分析",
          value: "month",
        },
        {
          name: "年度分析",
          value: "year",
        },
        {
          name: "选择日期分析",
          value: "datetimerange",
        },
      ],
      date: {
        currentYear: "",
        startYear: "",
        endYear: "",
      },
      dateMonth: {
        currentYear: "",
        startMonth: "",
        endMonth: "",
      },
      timeRangeList: [], // 选择时间范围
    };
  },

  methods: {
    pathSwitching(type) {
      if (type === "dd") {
        this.$router.push("./dd_left");
      } else if (type === "dx") {
        this.$router.push("./left_index");
      }
    },
    changeDepart(e) {
      console.log(e);
    },
    DateTimeRange(e) {
      if (e && e.length > 0) {
        this.timeRangeList = e.map((item) => this.util.format2(item));
        this.query();
      } else {
        this.timeRangeList = [];
      }

      console.log(this.timeRangeList);
    },
    mouseOver() {
      if (this.isClose) {
        this.open = true;
      }
    },
    // 关闭
    close() {
      this.isClose = false;
      this.open = false;
      setTimeout(() => {
        this.isClose = true;
      }, 1000);
    },
    //修改搜索类型
    changeType() {
      if (this.param.type === "month") {
        this.dateFormat = "yyyy年 M月";
        this.param.time = new Date();
        // this.changeDate()
        this.dateMonth.endMonth = this.util.endMonth(this.param.time);
        this.dateMonth.startMonth = this.util.startMonth(this.param.time);
        this.dateMonth.currentYear = this.util.currentYear(this.param.time);
      } else if (this.param.type === "year") {
        this.dateFormat = "yyyy年";
        this.param.time = new Date();
        // this.changeDate()
        console.log("yyyy年", this.param.time);
        this.date.currentYear = this.util.currentYear(this.param.time);
        this.date.startYear = this.util.startYear(this.param.time);
        this.date.endYear = this.util.endYear(this.param.time);
      }
      console.log(this.param.time);
    },
    changeDate(e) {
      if (this.param.type === "year") {
        this.date.currentYear = this.util.currentYear(e);
        this.date.startYear = this.util.startYear(e);
        this.date.endYear = this.util.endYear(e);
      } else if (this.param.type === "month") {
        this.dateMonth.endMonth = this.util.endMonth(e);
        this.dateMonth.startMonth = this.util.startMonth(e);
        this.dateMonth.currentYear = this.util.currentYear(e);
      }
    },
    // 医院信息
    changeHospital(e) {
      if(this.hospitalList && this.hospitalList.length > 0){
         this.hospitalList.forEach((item) => {
        if (item.hospitalId === e) {
          console.log(this.hospital_infor);
          (this.hospital_infor.hospitalName = item.hospitalName), // 医院名称
            (this.hospital_infor.hospitalId = item.hospitalId); // 医院id
        }
      });
      }
     
    },
    query(e) {
      let date = {
        startTime: null, //开始时间
        endTime: null, //结束时间
        year: null, //查询年份(必要)
        hospitalId: null, // 医院id
        hospitalName: null, // 医院名称
      };
      if (this.hospital_infor.hospitalId) {
        (date.hospitalId = this.hospital_infor.hospitalId),
          (date.hospitalName = this.hospital_infor.hospitalName);
      }
      if (this.param.type === "year") {
        (date.startTime = this.date.startYear), //开始时间
          (date.endTime = this.date.endYear), //结束时间
          (date.year = this.date.currentYear); //查询年份(必要)
        date.type = this.param.type;
      } else if (this.param.type === "month") {
        (date.startTime = this.dateMonth.startMonth), //开始时间
          (date.endTime = this.dateMonth.endMonth), //结束时间
          (date.year = this.dateMonth.currentYear); //查询年份(必要)
        date.type = this.param.type;
      } else if (this.param.type === "cumulative") {
        (date.startTime = null), //开始时间
          (date.endTime = null), //结束时间
          (date.year = "2022"); //查询年份(必要)
        date.type = this.param.type;
      } else if (this.param.type === "datetimerange" && this.timeRangeList) {
        date.startTime = this.timeRangeList[0]; //开始时间
        date.endTime = this.timeRangeList[1];
        date.type = this.param.type;
      }
      console.log("查询", date);
      
      this.$emit("rightQuery", date);
      this.close();
    },
  },
};
</script>
<style>
.select {
  border: 1px solid #1d418d !important;
}
.select .el-scrollbar {
  background-color: #1d418d;
}
.el-popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: #1d418d !important;
}
.el-popper[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: #1d418d !important;
}
.el-select-dropdown__item.selected {
  color: #1664ff !important;
}
.el-select-dropdown__item {
  color: #8daff8 !important;
}
.date-picker {
  border: 1px solid #1d418d;
  background-color: #112b62;
}
.date-picker .el-date-picker__header--bordered {
  border-bottom: solid 1px #1d418d;
}
.date-picker .el-picker-panel__icon-btn {
  color: #1664ff;
  font-size: 18px;
}
.el-date-picker__header-label {
  color: #1664ff;
}
.cell {
  color: #8daff8 !important;
}
.el-month-table td.current:not(.disabled) .cell {
  color: #1664ff !important;
}
.el-select__caret {
  color: #1664ff !important;
}
/* 自由选择日期时间 */
.el-picker-panel {
  background-color: #112b62;
  border: 1px solid #1d418d;
}
.el-picker-panel__footer {
  background-color: #112b62;
  border: 1px solid #1d418d;
}
.el-date-range-picker__content.is-left {
  border: 1px solid #1d418d;
}
.el-date-range-picker__time-header {
  border: 1px solid #1d418d;
}
/* .el-date-range-picker{
  width: 520px;
} */
.el-date-range-picker__editors-wrap
  .el-date-range-picker__time-picker-wrap
  .el-date-range-picker__editor
  .el-input__inner {
  background-color: #112b62;
  border: 1px solid #1d418d;
}
.el-date-table td.today span {
  color: #1664ff;
}
.el-date-table th {
  border-bottom: 1px solid #1d418d;
}
.el-date-table td.available {
  color: #8daff8;
}
.el-date-table td.available:hover {
  background-color: #013191;
}
.el-date-table td.prev-month {
  color: #8a94a9;
}
.el-date-table td.next-month {
  color: #8a94a9;
}
.el-date-table td.in-range div {
  background-color: #013191;
}
.el-input__inner {
  color: #8daff8;
}
.el-picker-panel__icon-btn {
  color: #8daff8;
}
.el-picker-panel {
  color: #8daff8;
}
.el-date-table th {
  color: #8daff8;
}
.el-picker-panel__footer .el-button.is-disabled.is-plain {
  background-color: #409eff;
  border: 1px solid #409eff;
}
.el-picker-panel__footer .el-button--default {
  background-color: #409eff;
  border: 1px solid #409eff;
  color: #fff;
}
.el-picker-panel__footer .el-button--default:hover {
  background-color: #409eff !important;
  color: #1664ff;
}
.el-input input::-webkit-input-placeholder {
  color: #8daff8;
}
.el-input input::-moz-input-placeholder {
  color: #8daff8;
}
.el-input input::-ms-input-placeholder {
  color: #8daff8;
}

/* .el-date-table td.next-month{
  color: #112b62;
} */
</style>
<style scoped>
:root {
  --color-menu-bg: #fff;
  --font-color-mi: #000;
  --font-color-mi-hover: #1890ff;
  --color-bg-mi-hover: #ececec;
  --border-radius-mi: 2px;
  --transition-menu-time: 0.2s;
  --color-line-bg: #d3d3d3;
}
.content {
  height: 1080px;
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0px;
}
.menu-box {
  letter-spacing: 0.5px;
  font-weight: 600;
  position: relative;
  width: fit-content;
  height: 1080px;
  padding-right: 12px;
  box-sizing: border-box;
}
.menu-box input[type="checkbox"] {
  display: none;
}

.menu-box > label {
  position: absolute;
  top: 48%;
  right: 25px;
  transform: translateX(50%);
  width: 19px;
  height: 34px;
  /* border-radius: 20px;
  box-shadow: 0px 0px 4px 0px #000; */
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-image: url("../assets/right-arrow.png");
  background-repeat: no-repeat;
}

.menu-box > label {
  transition: transform 1.5s;
  transform: rotate(180deg);
}

/* .menu-box > input#menu-btn:checked + label {
  transform: rotate(0deg);
} */

.menu {
  font-size: 18px;
  width: 0px;
  min-height: 100%;
  cursor: pointer;
  overflow: hidden;
  transition: width 0.5s;
  color: var(--font-color-mi);
  background-image: url("../assets/bg-popup.png");
  background-repeat: no-repeat;
}

/* .menu-box>input#menu-btn:checked~.menu {
    width: 597px;
} */
.open {
  width: 597px;
}
/* .menu-box>input#menu-btn:checked~label {
    background-color: red;

} */
/* 头部 */
.popup-top {
  width: 546px;
  height: 72px;
  background-image: url("../assets/popup-icon1.png");
  background-repeat: no-repeat;
}
.popup-text {
  width: 564px;
  height: 72px;
  line-height: 65px;
  text-align: center;
  background-image: linear-gradient(#e2ebff, #6da7ff);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  font-size: 34px;
}
.departSelect2 {
  width: 130px;
}
.departSelect {
  width: 130px;
  margin-left: 5px;
  margin-bottom: 10px;
  /* height: 40px; */
}
.departSelect /deep/ .el-input .el-input__inner {
  height: 40px !important;
  border: 1px solid #1d418d;
  border-radius: 8px;
  color: #8daff8;
  background-color: #112b62;
}
.open-content {
  padding: 55px 25px;
  height: 895px;
}
.elSelect {
  width: 520px;
  overflow: hidden;
}
.option {
  background-color: #1d418d;
}
.elButton {
  background-color: #1664ff;
  border: none;
  border-radius: 8px;
  width: 86px;
  font-size: 12px;
  margin-left: 5px;
}
.monthPicker {
  width: 120px;
  height: 40px;
  margin-left: 5px;
}
.monthPicker /deep/.el-input--mini .el-input__icon {
  display: none;
}
.monthPicker /deep/.el-input--mini .el-input__inner {
  padding-left: 10px;
  padding-right: 10px;
  height: 40px !important;
  border: 1px solid #1d418d;
  border-radius: 8px;
  color: #8daff8;
  background-color: #112b62;
}

.monthPicker /deep/.el-input__inner {
  padding-left: 10px;
  padding-right: 10px;
  height: 40px;
  border: 1px solid #1d418d;
  border-radius: 8px;
  color: #8daff8;
  background-color: #112b62;
}
.large-screen{
  margin-top: 35px;
}
.large-screen-type {
  width: 481px;
  margin-bottom: 20px;
}
.large-screen-type-img {
  width: 481px;
  height: 250px;
}
.is-large-screen-type {
  border: 4px solid #1c44b1;
}

.datetimerange {
  background-color: #112b62 !important;
  border: 1px solid #1d418d !important;
}
.datetimerange /deep/.el-range-input {
  color: #8daff8 !important ;
  background-color: #112b62 !important;
}
.datetimerange /deep/.el-range-separator {
  color: #8daff8 !important ;
}
.datetimerange /deep/.el-range-editor .el-range-input {
  background-color: #112b62;
  color: #8daff8;
}
.datetimerange /deep/.el-date-editor .el-range-separator {
  color: #8daff8;
}
.datetimerange /deep/.el-date-editor .el-range__icon {
  color: #8daff8;
}
</style>



// WEBPACK FOOTER //
// src/components/letPopup.vue